var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.416,
    height: 16.416,
    viewBox: "0 0 16.416 16.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    transform: "translate(0.1 0.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_225",
    "data-name": "Pfad 225",
    d: "M14.166,9.333v5.645a1.189,1.189,0,0,1-1.188,1.188H1.688A1.189,1.189,0,0,1,.5,14.977V3.688A1.189,1.189,0,0,1,1.688,2.5H7.333",
    transform: "translate(0 -0.699)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_25",
    "data-name": "Linie 25",
    x2: 3.904,
    transform: "translate(11.563 0.5)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_26",
    "data-name": "Linie 26",
    y1: 3.904,
    transform: "translate(15.467 0.5)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_27",
    "data-name": "Linie 27",
    y1: 7.158,
    x2: 7.158,
    transform: "translate(8.309 0.5)",
    fill: "none",
    stroke: "#3f3f3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.928640fcda72e60ae39e787e7d534431.svg";
export { ForwardRef as ReactComponent };